import React, { useState } from 'react'
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { useSelector } from 'react-redux'; 

const TableComponentReport = ({report, meters,parameter}) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
    // console.log(report)
    // console.log(meters)

    const columns = [];
    
      meters.map((i)=>{
            columns.push({field:i.dataIndex})
      })
      console.log(columns)


  return (
    <div
          className={`${isdarkMode ? "ag-theme-quartz-dark": "ag-theme-alpine"}`}
          style={{ height: '80vh' }}
        >
          <AgGridReact
            rowData={report}
            columnDefs={columns.length>1 ?columns :[]}
            defaultColDef={{
              resizable: true, 
            }}
            pagination={true}
            domLayout="normal" 
            suppressHorizontalScroll={false} 
          />
        </div>
  )
}

export default TableComponentReport